import { FormikProps } from 'formik';
import React, { useState } from 'react';
import { Input, InputProps } from '@chakra-ui/react';

import { ServiceType } from '../types';
import { SuggestionsList } from './SuggestionList';
import { useServiceQuery } from '../hooks/useServiceQuery';
import { getUniqueCategories } from '../utils/getUniqueCategoruies';
import { useAppSelector } from '../redux/store';

interface CategoryAutoCompleteProps {
  input: string;
  // setInput: React.Dispatch<React.SetStateAction<string>>;
  onOpenModal: () => void;
  categoryInputValue: string;
}

export const CategoryAutoComplete: React.FC<
  InputProps & FormikProps<ServiceType> & CategoryAutoCompleteProps
> = ({ id, categoryInputValue, setFieldValue, onOpenModal, ...rest }) => {
  const hasCookies = useAppSelector((state) => state.auth.hasCookies);

  // server states
  const { data } = useServiceQuery(hasCookies);

  const suggestions = getUniqueCategories(data!);

  // client states within this component
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
  const [filteredSuggestions, setFilteredSuggestions] = useState<string[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  // const [isInputFocused, setIsInputFocused] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const userInput = e.target.value;

    // filter our suggestions that don't contain the user's input
    const unLinked = suggestions.filter(
      (suggestion) =>
        suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );

    // setInput(e.target.value);
    setShowSuggestions(true);
    setFilteredSuggestions(unLinked);
    setActiveSuggestionIndex(0);
    setHasChanged(true);
    // for formik field
    setFieldValue(id!, e.target.value);
  };

  return (
    <>
      <Input
        {...rest}
        type="text"
        autoComplete="off"
        value={categoryInputValue}
        onChange={handleChange}
        onFocus={() => setShowSuggestions(true)}
        // onBlur={() => setShowSuggestions(false)}
      />
      {showSuggestions && (
        <SuggestionsList
          id={id!}
          // input={categoryInputValue}
          // setInput={setInput}
          categoryInputValue={categoryInputValue}
          hasChanged={hasChanged}
          allCategories={suggestions}
          filteredSuggestions={filteredSuggestions}
          activeSuggestionIndex={activeSuggestionIndex}
          onOpenModal={onOpenModal}
          setFieldValue={setFieldValue}
          setShowSuggestions={setShowSuggestions}
          setFilteredSuggestions={setFilteredSuggestions}
        />
      )}
    </>
  );
};
